const PasswordShow = () => (
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.10583 2.39488C7.39482 2.35482 7.69295 2.33333 8 2.33333C11.6301 2.33333 14.0121 5.33656 14.8124 6.52455C14.9092 6.66833 14.9576 6.74023 14.9847 6.85112C15.0051 6.93439 15.0051 7.06578 14.9847 7.14905C14.9576 7.25993 14.9088 7.3323 14.8113 7.47705C14.5981 7.79343 14.273 8.23807 13.8423 8.7203M4.24827 3.47669C2.71086 4.45447 1.66714 5.81292 1.18833 6.52352C1.09104 6.66791 1.0424 6.74011 1.01528 6.85099C0.994914 6.93426 0.994906 7.06563 1.01526 7.14891C1.04237 7.25979 1.09079 7.33168 1.18764 7.47545C1.9879 8.66344 4.36993 11.6667 8 11.6667C9.46369 11.6667 10.7245 11.1784 11.7605 10.5177M1.60027 1L14.3997 13M6.49157 5.58579C6.10553 5.94772 5.86675 6.44772 5.86675 7C5.86675 8.10457 6.82184 9 8 9C8.58908 9 9.12239 8.77614 9.50843 8.41421"
      stroke="#667085"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PasswordShow;
